function OrderCreatedLoadingScreenIndicator(): JSX.Element {
  return (
    <div className="flex flex-col justify-center items-center px-[5%] md:px-[10%] lg:px-[25%] ">
      <div className="w-[102px] h-[102px] rounded-full bg-dropDownBorder animate-pulse my-5" />
      <div className="h-[43px] bg-dropDownBorder animate-pulse w-[248px] rounded-sm" />
      <div className="h-[19px] bg-dropDownBorder animate-pulse w-[200px] rounded-sm my-3.5" />

      <div className=" md:p-6 py-6 px-3 w-full rounded-lg border border-roundedInputBorder">
        <div className="h-[19px] bg-dropDownBorder animate-pulse w-[119px] rounded-sm my-3.5" />
        <div className="flex items-center">
          <div className="my-6">
            <div className="h-[19px] bg-dropDownBorder animate-pulse md:w-[61px]  w-[61px] rounded-sm my-1" />
            <div className="h-[19px] bg-dropDownBorder animate-pulse md:w-[106px] w-[70px] rounded-sm" />
          </div>
          <div className="my-6 mx-6">
            <div className="h-[19px] bg-dropDownBorder animate-pulse md:w-[61px]  w-[61px] rounded-sm my-1" />
            <div className="h-[19px] bg-dropDownBorder animate-pulse md:w-[106px] w-[70px] rounded-sm" />
          </div>
          <div className="my-6">
            <div className="h-[19px] bg-dropDownBorder animate-pulse md:w-[61px]  w-[61px] rounded-sm my-1" />
            <div className="h-[19px] bg-dropDownBorder animate-pulse md:w-[106px] w-[70px] rounded-sm" />
          </div>
        </div>
        
      </div>
      <div className="flex items-center justify-between w-full my-4">
        <div className="h-[19px] bg-dropDownBorder animate-pulse md:w-[180px] w-[100px] rounded-sm" />
        <div className="h-[19px] bg-dropDownBorder animate-pulse md:w-[180px] w-[100px] rounded-sm" />
        <div className="h-[19px] bg-dropDownBorder animate-pulse md:w-[180px] w-[100px] rounded-sm" />
      </div>
    </div>
  );
}

export default OrderCreatedLoadingScreenIndicator;
